<template>
	<div>
		<div class="row">
			<div class="col">
				<h1>
					Edit a category
				</h1>
			</div>

			<div class="col-auto">
				<locale-switcher @change="fetchAgain" />
			</div>
		</div>
		<div class="row">
			<router-link :to="{ name: 'categories' }">
				<span class="fa fa-long-arrow-alt-left" />
				Return to Categories
			</router-link>
		</div>

		<form class="mt-4" @submit.prevent="saveCategory">
			<div class="form-group">
				<label for="name">
					<small class="text-muted">CATEGORY NAME</small>
				</label>
				<input type="text" class="form-control" name="name" placeholder="Name" v-model="name" required autofocus
					:disabled="loading">
			</div>

			<!-- <div class="form-group">
				<label for="name">
					<small class="text-muted">CATEGORY DESCRIPTION</small>
				</label>
				<textarea class="form-control" name="description" placeholder="Description" v-model="description" required autofocus :disabled="loading" />
			</div> -->

			<!-- <div class="form-group">
				<label for="name">
					<small class="text-muted">CATEGORY TAG (OPTIONAL)</small>
				</label>
				<input type="text" class="form-control" name="tag" placeholder="Tag" v-model="tag" autofocus :disabled="loading">
			</div> -->

			<!-- <div class="form-group">
				<label for="parent">
					<small class="text-muted">CATEGORY PARENT</small>
				</label>
				<select class="form-control" name="parent" v-model="parent_id" :disabled="loading">
					<option v-for="category in categories.filter(c => c.id != type.id)" :key="category.id" :value="category.id">
						{{ category.name }}
					</option>
				</select>
			</div> -->

			<div class="form-group">
				<label for="content">
					<small class="text-muted">CATEGORY IMAGE</small>
				</label>
				<file-input @change="setIcon" placeholder="Choose an image (replace old if set)" :disabled="loading" />
			</div>

			<!-- <div class="form-check mb-2">
				<input class="form-check-input" type="checkbox" id="is_featured" v-model="is_featured" :disabled="loading">
				<label class="form-check-label" for="is_featured">
					Is it a Dimashqi category?
				</label>
			</div> -->

			<!-- <div class="form-check mb-2">
				<input class="form-check-input" type="checkbox" id="has_dimensions" v-model="has_dimensions" :disabled="loading">
				<label class="form-check-label" for="has_dimensions">
					Products have dimensions?
				</label>
			</div> -->

			<!-- <div class="form-check mb-2">
				<input class="form-check-input" type="checkbox" id="can_upload_attachments" v-model="can_upload_attachments" :disabled="loading">
				<label class="form-check-label" for="can_upload_attachments">
					Product orders have the ability of attaching logos?
				</label>
			</div> -->

			<!-- <div class="form-group">
				<label>
					<small class="text-muted">CATEGORY ATTRIBUTES</small>
				</label>
				<multiselect v-model="attributes"
					:close-on-select="false"
					:options="attributes"
					placeholder="Search or add attribute"
					tag-placeholder="Add a new ttribute"
					multiple
					taggable
					@tag="addAttribute" />
			</div> -->

			<button type="submit" class="btn btn-primary ld-ext-right mt-3" :disabled="loading"
				:class="{running: loading}">
				{{ loading ? 'Saving…' : 'Save' }}
				<div class="ld ld-ring ld-spin" />
			</button>
		</form>

		<div class="alert alert-danger mt-4" v-if="!loading && error">
			<p class="mb-0 text-center">
				{{ error }}
			</p>
		</div>
	</div>
</template>

<script>
import store from '../../../store';
import { getError } from '../../../helpers';
import { mapGetters, mapState } from 'vuex';

import LocaleSwitcher from '../../LocaleSwitcher';
import FileInput from '../../FileInput';
import Multiselect from 'vue-multiselect';

export default {
	components: {
		'file-input': FileInput,
		'locale-switcher': LocaleSwitcher,
		'multiselect': Multiselect,
	},

	async beforeRouteEnter(to, from, next) {
		await store.dispatch('categories/fetchAll');

		return store.dispatch('categories/fetch', { id: to.params.id }).then(type => {
			next(vm => {
				vm.name = type.name;
				vm.description = type.description;
				vm.tag = type.tag;
				vm.is_featured = type.is_featured;
				vm.has_dimensions = type.has_dimensions;
				vm.can_upload_attachments = type.can_upload_attachments;
				vm.parent_id = type.parent_id;
				vm.attributes = type.attributes.map(c => c.name);
			});
		});
	},

	data() {
		return {
			name: '',
			description: '',
			tag: '',
			is_featured: false,
			has_dimensions: false,
			can_upload_attachments: false,
			attributes: [],
			parent_id: null,
			image: null,

			loading: false,
			error: '',
		};
	},

	computed: {
		...mapGetters({
			getTypeById: 'categories/getById',
		}),

		type() {
			return this.getTypeById(parseInt(this.$route.params.id));
		},

		...mapState({
			categories: state => state.categories.categories,
		})
	},

	methods: {
		saveCategory() {
			this.loading = true;

			return this.$store.dispatch('categories/update', {
				id: this.type.id,
				name: this.name,
				description: this.description,
				tag: this.tag,
				is_featured: this.is_featured,
				has_dimensions: this.has_dimensions,
				can_upload_attachments: this.can_upload_attachments,
				attributes: this.attributes,
				parent_id: this.parent_id,
				image: this.image,
			}).then(() => {
				this.$router.push({ name: 'categories' });
			}).catch(e => {
				this.error = getError(e);
				this.loading = false;
			});
		},

		fetchAgain({ oldValue }) {
			this.loading = true;

			this.$store.dispatch('categories/update', {
				id: this.type.id,
				name: this.name,
				description: this.description,
				tag: this.tag,
				is_featured: this.is_featured,
				has_dimensions: this.has_dimensions,
				can_upload_attachments: this.can_upload_attachments,
				attributes: this.attributes,
				parent_id: this.parent_id,
				image: this.image,
			}).then(async () => {
				const category = await this.$store.dispatch('categories/fetch', { id: this.$route.params.id });
				this.name = category.name;
				this.description = category.description;
				this.tag = category.tag;
				this.is_featured = category.is_featured;
				this.has_dimensions = category.has_dimensions;
				this.can_upload_attachments = category.can_upload_attachments;
				this.parent_id = category.parent_id;
				this.attributes = category.attributes.map(c => c.name);
			}).catch(e => {
				this.$store.dispatch('setContentLocale', oldValue);
				this.error = getError(e);
			}).finally(() => {
				this.loading = false;
			});
		},

		setIcon(files) {
			this.image = files[0];
		},

		addAttribute(attribute) {
			this.attributes.push(attribute);
		},
	},

	meta: {
		title: 'Edit a category',

		meta: [
			{ property: 'og:title', content: 'Edit a category / Al-Shayah' },
		],
	},
};
</script>
